import getApiConfig from '../config/apiConfig';

// Helper function to handle API responses
const handleResponse = async (response) => {
  if (!response.ok) {
    const error = await response.text();
    throw new Error(error);
  }
  return response.json();
};

export const lobService = {
  // Get all lines of business
  async getLineOfBusiness() {
    try {
      const { apiBaseUrl } = getApiConfig();
      const response = await fetch(`${apiBaseUrl}/lookup/lineofbusiness`);
      return handleResponse(response);
    } catch (error) {
      console.error('Error getting lines of business:', error);
      throw error;
    }
  },

  // Get LOB options (alias for getLineOfBusiness for compatibility)
  async getLOBOptions() {
    return this.getLineOfBusiness();
  }
}; 